'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@utils';

import { Container } from '../ui';
import { isNavigationItemActive } from './_utils';
import { NavigationItem } from './types';
import { useMenuItems } from './useMenuItems';

export const HorizontalNav = ({ className }: { className?: string }) => {
	const pathname = usePathname();
	const { menuItems } = useMenuItems();

	const NavigationItem = ({ item, active }: { item: NavigationItem; active?: boolean }) => {
		return (
			<div className="group relative flex h-13 flex-col">
				<Link
					href={item.href}
					className={cn(
						'decoration-light-link decoration-1 underline-offset-2',
						'text-light-text relative z-20 flex h-13 cursor-pointer items-center justify-center px-4',
						'group-hover:text-light-heading group-hover:bg-light-background-alt group-hover:underline',
					)}
				>
					{item.icon && !item.iconLabel ? (
						<div className="flex items-center">{item.icon(active)}</div>
					) : item.icon && item.iconLabel ? (
						<div className="flex items-center justify-center gap-3">
							{item.icon(active)}
							<p
								className={cn(
									'group-hover:text-light-link truncate text-left text-xs md:text-sm',
									active && 'text-light-heading font-semibold',
								)}
							>
								{item.iconLabel}
							</p>
						</div>
					) : (
						<p
							className={cn(
								'group-hover:text-light-link truncate',
								active && 'text-light-heading font-semibold',
							)}
						>
							{item.label}
						</p>
					)}
				</Link>
				<div
					className={cn(
						'absolute -bottom-2 z-10 h-2 w-full bg-transparent',
						'group-hover:bg-light-action-primary-hover',
						active && 'bg-neutral-lightest',
					)}
				/>
			</div>
		);
	};

	return (
		<nav
			className={cn(
				'border-light-design-accent relative border-b-8',
				'bg-neutral-lightest hidden h-auto w-full flex-col lg:flex',
				className,
			)}
		>
			<Container className="relative z-0 flex w-full flex-wrap">
				{menuItems.map(item => {
					return (
						<NavigationItem
							key={item.href}
							item={item}
							active={isNavigationItemActive(item, pathname)}
						/>
					);
				})}
			</Container>
		</nav>
	);
};
